import { EventEmitter } from "events";
import { OneNoteUserEventsKeys } from "../../../frontend/common/telemetry/OneNoteEventsKeys";
import { LogEvents } from "../../../utils/LogEvents";
import { HostAppSettingName, HostAppSettings } from "../../office-js/HostAppSettings";
import { EventCategory, EventDirection } from "../../TelemetryLogger/LogEvent";
import { HostAppEvent } from "./HostAppEventReceiver";

export class HostAppEventHandler extends EventEmitter {

    constructor() {
        super();
    }

    public HandleEvent(event: HostAppEvent, eventInfo: any) {
        switch (event) {
            case HostAppEvent.AUDIO_PLAYER_SEEK_TO:
                LogEvents.OneNoteUserEvents.FlushEventAdhoc(
                  [{ key: OneNoteUserEventsKeys.TranscriptionSessionId, value: HostAppSettings.GetSettingAsString(HostAppSettingName.TranscriptionSessionId) },
                  { key: OneNoteUserEventsKeys.EventCategory, value: EventCategory.Audio },
                  { key: OneNoteUserEventsKeys.EventType, value: HostAppEvent[HostAppEvent.AUDIO_PLAYER_SEEK_TO]},
                  { key: OneNoteUserEventsKeys.EventDirection, value: EventDirection.Received },
                  { key: OneNoteUserEventsKeys.EventInfo, value: String(eventInfo.timestamp) }]);
                  //ToDo: Will log Transcription State as well

                  this.emit(HostAppEvent[HostAppEvent.AUDIO_PLAYER_SEEK_TO], eventInfo.timestamp);
                break;
            case HostAppEvent.AUDIO_PLAYER_STOP:
                LogEvents.OneNoteUserEvents.FlushEventAdhoc(
                  [{ key: OneNoteUserEventsKeys.TranscriptionSessionId, value: HostAppSettings.GetSettingAsString(HostAppSettingName.TranscriptionSessionId) },
                  { key: OneNoteUserEventsKeys.EventCategory, value: EventCategory.Audio },
                  { key: OneNoteUserEventsKeys.EventType, value: HostAppEvent[HostAppEvent.AUDIO_PLAYER_STOP]},
                  { key: OneNoteUserEventsKeys.EventDirection, value: EventDirection.Received }]);
                  //ToDo: Will log Transcription State as well

                this.emit(HostAppEvent[HostAppEvent.AUDIO_PLAYER_STOP]);
                break;
        }
    }
}